import { useEffect } from 'react';

import { urlUtils } from '../../utils';
import { mapStateToProps, OwnProps } from '../../weborder/component/Voucher';

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

export function AddVoucher(props: Props): JSX.Element {
  const { params } = props;

  useEffect(() => {
    const { vrid, type, id, concessionStoreId } = params;
    const hasConcessionStoreId = concessionStoreId
      ? `/${concessionStoreId}`
      : '';
    urlUtils.navigateToHash(
      `/restaurant/${vrid}/${type}/${id}${hasConcessionStoreId}`,
    );
  }, []);

  return null;
}
